var DiseaseType = /* @__PURE__ */ ((DiseaseType2) => {
  DiseaseType2["INFECTIOUS"] = "INFECTIOUS";
  DiseaseType2["HEART"] = "HEART";
  DiseaseType2["CIRCULATORY_VASCULAR"] = "CIRCULATORY_VASCULAR";
  DiseaseType2["LUNG"] = "LUNG";
  DiseaseType2["BONE_MUSCULAR_COGNITIVE_TISSUE"] = "BONE_MUSCULAR_COGNITIVE_TISSUE";
  DiseaseType2["CANCER"] = "CANCER";
  DiseaseType2["METABOLIC"] = "METABOLIC";
  DiseaseType2["GASTRIC_INTESTINAL"] = "GASTRIC_INTESTINAL";
  DiseaseType2["LIVER_BILIARY"] = "LIVER_BILIARY";
  DiseaseType2["KIDNEY_URINARY_TRACT"] = "KIDNEY_URINARY_TRACT";
  DiseaseType2["PSYCHOLOGICAL"] = "PSYCHOLOGICAL";
  DiseaseType2["MEDICATION_ALLERGIES"] = "MEDICATION_ALLERGIES";
  DiseaseType2["OTHER_ALLERGIES"] = "OTHER_ALLERGIES";
  DiseaseType2["SURGERY"] = "SURGERY";
  DiseaseType2["OTHER"] = "OTHER";
  return DiseaseType2;
})(DiseaseType || {});
export {
  DiseaseType
};
